import script from "./mobile_events.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile_events.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__